import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/auth';
import { AuthShell } from '@/components/layout/AuthShell';
import { EnrollMfaForm } from '@/features/auth/EnrollMfaForm';
import { bootstrapSession } from '@/api/client';

export const Route = createFileRoute('/enroll-mfa')({
  beforeLoad: async () => {
    await bootstrapSession();
    const status = useAuthStore.getState().status;
    if (status === 'anonymous') throw redirect({ to: '/login' });
    if (status === 'authed') throw redirect({ to: '/dashboard' });
  },
  component: EnrollMfaPage,
});

function EnrollMfaPage() {
  const { t } = useTranslation('auth');
  return (
    <AuthShell title={t('enroll.title')} subtitle={t('enroll.subtitle')}>
      <EnrollMfaForm />
    </AuthShell>
  );
}
